var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"gts-badge",class:`${_vm.classPrefix}-${_vm.status}`},[_vm._v(_vm._s(_vm.label))])
}
var staticRenderFns = []

export { render, staticRenderFns }